angular.module('components.editor.EditorController', [
  'components.editor.EditorService'
])

/**
 * The EditorController manages scope logic and user
 * interaction.
 *
 * @class EditorController
 * @constructor
 * @module components.widgets.EditorController
 */
.controller('EditorController', [
  '$scope',
  'EditorService',
  function ($scope, EditorService) {
    'use strict';

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      EditorService.editor = ace.edit('editor');
      EditorService.editor.setTheme('ace/theme/github');
      EditorService.editor.session.setMode('ace/mode/json');
      EditorService.editor.session.setOption('useWorker', true);
      EditorService.editor.$blockScrolling = Infinity;
      EditorService.editor.setValue(JSON.stringify($scope.model, null, '\t'));
      EditorService.editor.clearSelection();
    }

    initialize();
  }
]);
